import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { IconAdd } from "../icons/IconAdd";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonAdd: React.FC<MprcButtonProps> = ({ text, title, startIcon, ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonAdd.text;
    const lTitle = title || theme.buttons.ButtonAdd.title;

    return (
        <MprcButton
            {...rest}
            title={lTitle}
            text={lText}
            startIcon={startIcon === null ? null : startIcon ?? <IconAdd fixedWidth />}
        />
    );
};
